import PropTypes from 'prop-types';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// -- RETRIEVE IMAGES FROM LEAFLET CDN --
const customIcon = new L.Icon({
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

/**
 *
 * @param root0
 * @param root0.center
 * @returns OpenStreetMapComponent
 */
function OpenStreetMapComponent({ center }) {

    const position = [center.lat, center.lng];

    return (
        <div className='w-full h-64 sm:h-72 md:h-80 lg:h-96 border border-black' data-cy='geolocation-map'>
            <MapContainer
                center={position}
                zoom={10}
                className='w-full h-full'
                scrollWheelZoom={false}
            >
                <TileLayer
                    url={process.env.REACT_APP_API_OPEN_STREET_MAP_URL}
                    attribution='&copy; OpenStreetMap'
                />
                <Marker position={position} icon={customIcon} />
            </MapContainer>
        </div>
    );
}

OpenStreetMapComponent.propTypes = {
    center: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired
    }).isRequired
};

export default OpenStreetMapComponent;